export const IconFolder = (props: { size?: number }) => {
	const width: number = props.size ?? 24;
	return (
		<svg width={width} height={width} viewBox={`0 -960 960 960`} fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill="#F19E39"
				fillOpacity="0.6"
				d="M172.31-180Q142-180 121-201q-21-21-21-51.31v-455.38Q100-738 121-759q21-21 51.31-21h219.61l80 80h315.77Q818-700 839-679q21 21 21 51.31v375.38Q860-222 839-201q-21 21-51.31 21H172.31Z"
			/>
		</svg>
	);
};
